// extracted by mini-css-extract-plugin
module.exports = {"spinner":"VinylSpinner_spinner__2gadl","spin":"VinylSpinner_spin__2aEV3"};